import { IIcon } from './iconConstants'
const SpannerIcon = ({ width, height, stoke }: IIcon) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.002 9.91a5.332 5.332 0 0 1 6.664-7.521L11.334 6l.472 2.194L14 8.666l3.611-3.332a5.332 5.332 0 0 1-7.522 6.664l-4.67 5.415a2.003 2.003 0 0 1-2.832-2.832l5.415-4.67z'
        stroke={stoke}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export default SpannerIcon
